export class Sheet {
  id: number
  sheet_group_key: number
  nendo: number
  grade: number
  page_count: number
  kind: number
  allot: number
  name: string
  subject_id: number
  subject_name: string
  field_names_completed: boolean
  corretct_image_completed: boolean

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_group_key = sheet.sheet_group_key;
    this.nendo = sheet.nendo;
    this.grade = sheet.grade;
    this.page_count = sheet.page_count;
    this.kind = sheet.kind;
    this.allot = sheet.allot;
    this.name = sheet.name;
    this.subject_id = sheet.subject_id;
    this.subject_name = sheet.subject_name;
    this.field_names_completed = sheet.field_names_completed;
    this.corretct_image_completed = sheet.corretct_image_completed;
  }
}

export class Student {
  user_id: number
  login_id: string
  student_num: number
  name: string
  nendo: number
  grade: number
  room_name: string
  number: number

  constructor(student: any){
    this.user_id = student.user_id;
    this.login_id = student.login_id;
    this.student_num = student.student_num;
    this.name = student.name;
    this.nendo = student.nendo;
    this.grade = student.grade_id;
    this.room_name = student.room_name;
    this.number = student.number;
  }
}